import React, { useState } from 'react';
import { invitationService } from '../services/invitationService';
import { Box, Button, TextField, Typography, Chip, Paper } from '@mui/material';
import { useSnackbar } from 'notistack';

const InvitationForm = ({ eventId, onInvitationsSent }) => {
    const [email, setEmail] = useState('');
    const [emails, setEmails] = useState([]);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleAddEmail = () => {
        if (email && !emails.includes(email)) {
            setEmails([...emails, email]);
            setEmail('');
        }
    };

    const handleRemoveEmail = (emailToRemove) => {
        setEmails(emails.filter(email => email !== emailToRemove));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (emails.length === 0) {
            enqueueSnackbar('Please add at least one email address', { variant: 'warning' });
            return;
        }

        setLoading(true);
        try {
            await invitationService.sendInvitations(eventId, emails);
            enqueueSnackbar('Invitations sent successfully', { variant: 'success' });
            setEmails([]);
            if (onInvitationsSent) {
                onInvitationsSent();
            }
        } catch (error) {
            enqueueSnackbar(error.response?.data?.message || 'Failed to send invitations', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Paper elevation={3} sx={{ p: 4, mt: 3 }}>
            <Typography variant="h6" gutterBottom>
                Send Invitations
            </Typography>
            <Box component="form" onSubmit={handleSubmit}>
                <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                    <TextField
                        fullWidth
                        label="Email Address"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter email address"
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddEmail}
                        disabled={!email || emails.includes(email)}
                    >
                        Add
                    </Button>
                </Box>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                    {emails.map((email) => (
                        <Chip
                            key={email}
                            label={email}
                            onDelete={() => handleRemoveEmail(email)}
                        />
                    ))}
                </Box>

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading || emails.length === 0}
                    fullWidth
                    sx={{ color: '#FFFFFF' }}
                >
                    {loading ? 'Sending...' : 'Send Invitations'}
                </Button>
            </Box>
        </Paper>
    );
};

export default InvitationForm; 